__webpack_require__.p = "/reports-analytics-generated-property/referrals-hub/";